// Don't care about fetch polyfills on the client, so just expose the browser one
export default globalThis.fetch;
